"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdlib_core_1 = require("@groupby/stdlib-core");
class UnknownStatusCodeException extends stdlib_core_1.Exception {
    constructor(union) {
        super(UnknownStatusCodeException.buildMessage(union));
        this[Symbol.toStringTag] = 'UnknownStatusCodeException';
        this.name = 'UnknownStatusCodeException';
    }
    static buildMessage(union) {
        if (union === undefined) {
            return 'The response status code is unknown.';
        }
        if (typeof union === 'number') {
            return `The response status code '${union}' is unknown.`;
        }
        return union;
    }
}
exports.UnknownStatusCodeException = UnknownStatusCodeException;
//# sourceMappingURL=unknown-status-code-exception.js.map